const keys = {
    'BACKSPACE': 8,
    'TAB': 9,
    'ENTER': 13,
    'SHIFT': 16,
    'CTRL': 17,
    'ALT': 18,
    'ESC': 27,
    'ESCAPE': 27,
    'SPACE': 32,
    'END': 35,
    'HOME': 36,
    'LEFTARROW': 37,
    'ARROWLEFT': 37,
    'UPARROW': 38,
    'ARROWUP': 38,
    'RIGHTARROW': 39,
    'ARROWRIGHT': 39,
    'DOWNARROW': 40,
    'ARROWDOWN': 40,
    'INSERT': 45,
    'DELETE': 46
};

export const keyCodes = Object.keys(keys).map(k => keys[k]);
export default keys;